module.exports = __webpack_public_path__ + "fonts/montserrat-thinitalic-webfont.a43b46d.woff";